























import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

@Component({})
export default class NavigationMenuComponent extends Vue {
    @Action('signUserUp', { namespace: 'user' }) signUserUp: any;
    @Action('signUserOut', { namespace: 'user' }) signUserOut: any;
    @Getter('isKnownUser', { namespace: 'user' }) isKnownUser!: boolean;

    /**
     * Call the login / sign up process of firebase
     */
    login($event: Event) {
        this.signUserUp();
    }

    /**
     * calls the logout in the store
     */
    logout() {
        this.signUserOut();
    }
}
